import {Component} from '@angular/core';
import {UntypedFormBuilder} from '@angular/forms';
import {PartnersResource} from '../../model/model-resource';
import {ResourceAutoCompleteComponent} from './resource-auto-complete.component';
import {Partner} from '../../model/partner';

@Component({
  selector: 'app-partner-auto-complete',
  templateUrl: './resource-auto-complete.component.html',
  styleUrls: ['./resource-auto-complete.component.scss']
})
export class PartnerAutoCompleteComponent extends ResourceAutoCompleteComponent<Partner> {
  constructor(builder: UntypedFormBuilder, resource: PartnersResource) {
    super(builder, resource);
  }
}
